import FroalaContent from "@/components/common/FroalaContent";
import BaseModule from "@/components/site-builder/BaseModule";
import TextField from "@/components/site-builder/TextField";
import { useClientConfig } from "@/context/clientConfig";
import { convertImageSrcToImgixInText } from "@/utils/image/convertImageSrcToImgixInText";
import type { TextContentModuleType } from "./types";

export interface TextContentModuleProps {
  module: TextContentModuleType;
}

export default function TextContentModule(props: TextContentModuleProps) {
  const { module } = props;
  const {
    body: { body },
  } = module;
  const { imgix: imgixConfig } = useClientConfig();

  return (
    <BaseModule module={module}>
      <FroalaContent>
        <TextField
          field={{
            ...body,
            text: convertImageSrcToImgixInText(body.text, imgixConfig),
          }}
          type="text-regular"
        />
      </FroalaContent>
    </BaseModule>
  );
}
